export default __webpack_public_path__ + "static/media/q.78d1dd24.png";